// Generated by scripts/generate_env_example.py. Do not edit.
// Explicit property reads let Vite replace every public build value.
export const frontendBuildEnvironment: Readonly<Record<string, unknown>> = {
  "VITE_API_HEALTH_POLL_MS": import.meta.env?.VITE_API_HEALTH_POLL_MS,
  "VITE_API_KEY": import.meta.env?.VITE_API_KEY,
  "VITE_API_URL": import.meta.env?.VITE_API_URL,
  "VITE_AUTO_SYNC_INTERVAL_DEFAULT": import.meta.env?.VITE_AUTO_SYNC_INTERVAL_DEFAULT,
  "VITE_COMMAND_PALETTE_RECENT_COUNT": import.meta.env?.VITE_COMMAND_PALETTE_RECENT_COUNT,
  "VITE_DEFAULT_AI_LANGUAGE": import.meta.env?.VITE_DEFAULT_AI_LANGUAGE,
  "VITE_DEFAULT_AI_MODEL": import.meta.env?.VITE_DEFAULT_AI_MODEL,
  "VITE_DYNAMIC_SYNC_EXPECTED_POSTS_DEFAULT": import.meta.env?.VITE_DYNAMIC_SYNC_EXPECTED_POSTS_DEFAULT,
  "VITE_QUERY_STALE_TIME_MS": import.meta.env?.VITE_QUERY_STALE_TIME_MS,
  "VITE_RAG_STATUS_POLL_MS": import.meta.env?.VITE_RAG_STATUS_POLL_MS,
  "VITE_RETENTION_LOG_DAYS_DEFAULT": import.meta.env?.VITE_RETENTION_LOG_DAYS_DEFAULT,
  "VITE_RETENTION_PAYLOAD_DAYS_DEFAULT": import.meta.env?.VITE_RETENTION_PAYLOAD_DAYS_DEFAULT,
  "VITE_RETENTION_POST_DAYS_DEFAULT": import.meta.env?.VITE_RETENTION_POST_DAYS_DEFAULT,
  "VITE_RETENTION_REPORT_DAYS_DEFAULT": import.meta.env?.VITE_RETENTION_REPORT_DAYS_DEFAULT,
  "VITE_RETENTION_REPORT_MAX_DEFAULT": import.meta.env?.VITE_RETENTION_REPORT_MAX_DEFAULT,
  "VITE_RETENTION_SHARED_LOG_DAYS_DEFAULT": import.meta.env?.VITE_RETENTION_SHARED_LOG_DAYS_DEFAULT,
  "VITE_SYNC_JOB_FALLBACK_POLL_MS": import.meta.env?.VITE_SYNC_JOB_FALLBACK_POLL_MS,
  "VITE_SYNC_JOB_TIMEOUT_MS": import.meta.env?.VITE_SYNC_JOB_TIMEOUT_MS,
  "VITE_SYNC_META_MIN_INTERVAL_MS": import.meta.env?.VITE_SYNC_META_MIN_INTERVAL_MS,
  "VITE_TELEGRAM_WEB_DOMAIN": import.meta.env?.VITE_TELEGRAM_WEB_DOMAIN,
  "VITE_TRANSLATION_DEBOUNCE_MS": import.meta.env?.VITE_TRANSLATION_DEBOUNCE_MS,
  "VITE_TRANSLATION_MAX_BATCH_CHARS": import.meta.env?.VITE_TRANSLATION_MAX_BATCH_CHARS,
}
